import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AdminService } from '../../admin.service';
import { TicketsComponent } from '../tickets.component';
interface DialogData {}

@Component({
  selector: 'app-update-ticket',
  templateUrl: './update-ticket.component.html',
  styleUrls: ['./update-ticket.component.scss']
})
export class UpdateTicketComponent implements OnInit {
  ticketData: any;
  updateTicketForm: FormGroup;
  uploadedFileName: any;
  formdata: FormData;
  isSubmitted: boolean;
  showLoader: boolean;
  attachmentUrl: any;
  techSupport: boolean;

  constructor(private toastr: ToastrService,private httpClient: HttpClient, private adminService: AdminService,private _formBuilder: FormBuilder, private dialogRef: MatDialogRef<TicketsComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.ticketData = this.data["data"];
    this.getSelectedTicketData(); 
    this.formCreate();
  }

  getSelectedTicketData() {
    this.adminService.getSelectedTicketData(this.ticketData).subscribe((response:any)=>{   
      this.techSupport = false;  
      if(response.data.category == 'Technical Support') {
        this.techSupport = true;   
      }      
      this.updateTicketForm.patchValue(
        {
          ticketType: response.data.category,
          quoteNumber: response.data.reference_number,
          message: response.data.message,
          status:  response.data.status
         })

         this.uploadedFileName = response.data.attachment_name;
         this.attachmentUrl = response.data.attachment_url;
    });    
  }

  formCreate() {
    this.updateTicketForm = this._formBuilder.group({
      ticketType: ['', Validators.required],
      quoteNumber: [''],
      message: ['', Validators.required],
      status: [''],
      uploadFile: ['']
    });
  }

  onFileSelected(fileInput) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(fileInput.target.files[0]);
      this.formdata = new FormData();
      this.formdata.append('attachement', fileInput.target.files[0]);
      this.uploadedFileName = fileInput.target.files[0].name;
    }
   }

   updateTicket() {
    this.showLoader = true;
    this.isSubmitted = true;
    if (this.updateTicketForm.invalid) {
      this.showLoader = false;
      return false;
    } else {
    if(this.formdata == undefined) {
      this.formdata = new FormData();
    }
    this.formdata.append('message', this.updateTicketForm.get('message').value);
    this.formdata.append('status', this.updateTicketForm.get('status').value);
    this.httpClient.patch<any>(`${environment.customerUrl}api/v1/ticket/` + this.ticketData, this.formdata).subscribe((value) => {
      console.log(value)
      this.dialogRef.close();
      this.showLoader = false;
    },
      error => {
        this.toastr.error(error.error.message, 'Error');
      });
    }
   }

   openDocument() {
    window.open(this.attachmentUrl, "_blank");
   }

  close() {
    this.dialogRef.close()
  }
}
